<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<div class="page-indicator">
    <div *ngIf="serviceFlag && claimsDataService.lossCauseTypesLoaded" class="claims-track-page-title-wrap claims-track-page-title--overview">
        Claim Contacts
        <small class="claims-track-company">
            <strong style="text-transform:uppercase;">{{claimsDataService.getLossCause(claimInfo.lossCause)}}</strong>
            ({{claimInfo.claimNumber}})
            <strong style="text-transform:uppercase;">{{claimInfo.claimState}}</strong>
            <span *ngIf="claimInfo.incidentOnly">(Record Only)</span>
        </small>
        <small class="claims-track-number">Incident date: {{claimInfo.lossDate| date:'MM/dd/yyyy'}}</small>
    </div>
</div>
<div class="content-container-light-blue bolt-space-bottom-sm">
    <main class="content-container-light-blue__inner" role="main">
        <article *ngIf="claimOwnerInfo()" class="claims-track-claim-content">
            <h2>General Claim <span class="font-weight-light">Questions</span></h2>
            <div class="claims-track-claim-content__text-box">
                <dl>
                    <dd><em>{{claimOwner[0].adjuster.displayName}}</em></dd>
                    <dd><a href="tel:{{claimOwner[0].adjuster.phoneNumber}}" title="{{claimOwner[0].adjuster.phoneNumber}}">{{claimOwner[0].adjuster.phoneNumber}}</a>
                    </dd>
                    <dd *ngIf="claimOwnerEmail"><a href="mailto:{{claimOwner[0].adjuster.email}}" title="{{claimOwner[0].adjuster.email}}">{{claimOwner[0].adjuster.email}}</a></dd>
                </dl>
            </div>
        </article>

        <article *ngIf="vehicleDamageInfo()" class="claims-track-claim-content">
            <h2>Vehicle Damage <span class="font-weight-light">Questions</span></h2>
            <div class="claims-track-claim-content__text-box">
                <dl>
                    <dd><em>{{vehicleDamage[0].adjuster.displayName}}</em></dd>
                    <dd><a href="tel:{{vehicleDamage[0].adjuster.phoneNumber}}" title="{{vehicleDamage[0].adjuster.phoneNumber}}">{{vehicleDamage[0].adjuster.phoneNumber}}</a>
                    </dd>
                    <dd *ngIf="vehicleDamageEmail"><a href="mailto:{{vehicleDamage[0].adjuster.email}}" title="{{vehicleDamage[0].adjuster.email}}">{{vehicleDamage[0].adjuster.email}}</a></dd>
                </dl>
            </div>
        </article>

        <article *ngIf="propertyDamageInfo()" class="claims-track-claim-content">
            <h2>Property Damage <span class="font-weight-light">Questions</span></h2>
            <div class="claims-track-claim-content__text-box">
                <dl>
                    <dd><em>{{propertyDamage[0].adjuster.displayName}}</em></dd>
                    <dd><a href="tel:{{propertyDamage[0].adjuster.phoneNumber}}" title="{{propertyDamage[0].adjuster.phoneNumber}}">{{propertyDamage[0].adjuster.phoneNumber}}</a>
                    </dd>
                    <dd *ngIf="propertyDamageEmail"><a href="mailto:{{propertyDamage[0].adjuster.email}}" title="{{propertyDamage[0].adjuster.email}}">{{propertyDamage[0].adjuster.email}}</a></dd>
                </dl>
            </div>
        </article>

        <article *ngIf="injuryInfo()" class="claims-track-claim-content">
            <h2>Injury <span class="font-weight-light">Questions</span></h2>
            <div class="claims-track-claim-content__text-box">
                <dl>
                    <dd><em>{{injury[0].adjuster.displayName}}</em></dd>
                    <dd><a href="tel:{{injury[0].adjuster.phoneNumber}}" title="{{injury[0].adjuster.phoneNumber}}">{{injury[0].adjuster.phoneNumber}}</a></dd>
                    <dd *ngIf="injuryEmail"><a href="mailto:{{injury[0].adjuster.email}}" title="{{injury[0].adjuster.email}}">{{injury[0].adjuster.email}}</a></dd>
                </dl>
            </div>
        </article>
    </main>
</div>
<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
